import React from 'react';
import { translatePartOfStringWithLink } from '../../../../lib/StringUtils/StringHTMLUtils';
import { EventFormTemplate } from '../../../../_blocks/PageManagement/forms/CreatePageForm/partials/EventFormTemplate';
import {
  Form,
  RequiredHelpPhrase,
  SonForm,
  SubmitButton,
  TextAreaParam,
  TextParam,
  UrlParam,
  useForm,
} from '../../../../_lib/Form2';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { useAppContext } from '../../../../contexts/AppContext/AppContext';
import { Namespace } from '../../../../translation/namespace';
import { DateRangeParam } from '../../../../_lib/Form2/types/DateRangeParam';
import { useDelayed } from '../../../../hooks/useDelayed';

type EventCreateOrUpdateProperties = {
  translationNamespace: string;
  form: SonForm<
    | DateRangeParam<'daterange'>
    | TextAreaParam<'additionalInfo'>
    | TextParam<'location'>
    | UrlParam<'conferenceRoomUrl'>
  >;
  refreshBlock: () => void;
};

/**
 * With the component you can create or update meetings.
 */
function EventCreateOrUpdate({ form, refreshBlock }: EventCreateOrUpdateProperties) {
  const { t } = useSonTranslation('EventDetails');
  const { portalConfiguration } = useAppContext();
  const delayedRefresh = useDelayed(refreshBlock);

  const { formProps, fetchState, params } = useForm({ form, onSuccess: delayedRefresh });

  const additionalInfo = params.getByName('additionalInfo');
  const conferenceRoomUrl = params.getByName('conferenceRoomUrl');
  const location = params.getByName('location');
  const daterange = params.getByName('daterange');

  return (
    <Form {...formProps} id="event-details-update-form">
      <RequiredHelpPhrase />
      <EventFormTemplate
        dateRangeParam={daterange}
        additionalInfoParam={additionalInfo}
        locationParam={location}
        conferenceRoomUrlParam={conferenceRoomUrl}
      />
      <SubmitButton
        buttonLabel={t(`edit.button`)}
        messageSuccess={t(`edit.status.success`)}
        messageSending={t(`edit.status.sending`)}
        messageFail={
          <>
            {t(`edit.status.fail`)}
            {translatePartOfStringWithLink(
              `${Namespace.phrases}:ifProblemCallLinkedSupport`,
              portalConfiguration.son_portal_support_email
                ? `mailto:${portalConfiguration.son_portal_support_email}`
                : null
            )}
          </>
        }
        fetchState={fetchState}
      />
    </Form>
  );
}

export default EventCreateOrUpdate;
